export default __webpack_public_path__ + "static/media/launch.52cc088d.png";